// Wrappers del catálogo de mantenciones periódicas (ADR-0083) para la
// sección Administración · Mantenciones (plan 2026-10-30 §2.7, T-aviu).
// lib/api/endpoints/maintenance.ts sólo cubre la lectura por tienda y
// las marcas de realización; la superficie de configuración
// (GET/POST/PATCH /maintenance-items, GET/PUT /maintenance-items/:id/
// assets) vive aquí, junto a la única pantalla que la usa.

import {
  maintenanceItemAdminListResponse,
  maintenanceItemAdminSummary,
  maintenanceItemAssetsResponse,
  type MaintenanceItemAdminListResponse,
  type MaintenanceItemAdminSummary,
  type MaintenanceItemAssetsResponse,
  type MaintenanceItemCreateBody,
  type MaintenanceItemUpdateBody,
} from "@bitacorapro/api-types";
import { request } from "../../../lib/api/client";

export const mantencionesApi = {
  // GET /maintenance-items — toda la organización, archivadas incluidas
  // (`active: false`); la pantalla filtra.
  list: async (): Promise<MaintenanceItemAdminListResponse> => {
    const json = await request<unknown>("GET", "core", "/maintenance-items");
    return maintenanceItemAdminListResponse.parse(json);
  },
  // POST /maintenance-items — cadenceDays obligatorio; `scope: "assets"`
  // exige al menos una tienda (MAINTENANCE_ITEM_SCOPE_EMPTY).
  create: async (body: MaintenanceItemCreateBody): Promise<MaintenanceItemAdminSummary> => {
    const json = await request<unknown>("POST", "core", "/maintenance-items", { body });
    return maintenanceItemAdminSummary.parse(json);
  },
  // PATCH /maintenance-items/:id — label / cadenceDays / active / scope
  // (+ assetIds en el mismo request cuando el alcance pasa a tiendas).
  patch: async (
    itemId: string,
    body: MaintenanceItemUpdateBody
  ): Promise<MaintenanceItemAdminSummary> => {
    const json = await request<unknown>("PATCH", "core", `/maintenance-items/${itemId}`, { body });
    return maintenanceItemAdminSummary.parse(json);
  },
  // GET /maintenance-items/:id/assets — qué tiendas la llevan hoy.
  listAssets: async (itemId: string): Promise<MaintenanceItemAssetsResponse> => {
    const json = await request<unknown>("GET", "core", `/maintenance-items/${itemId}/assets`);
    return maintenanceItemAssetsResponse.parse(json);
  },
  // PUT /maintenance-items/:id/assets — reemplazo completo.
  putAssets: async (itemId: string, assetIds: string[]): Promise<MaintenanceItemAssetsResponse> => {
    const json = await request<unknown>("PUT", "core", `/maintenance-items/${itemId}/assets`, {
      body: { assetIds },
    });
    return maintenanceItemAssetsResponse.parse(json);
  },
};
